import PageHeader from '../components/PageHeader';
import CTA from '../components/CTA';
import { ProjectSearchControls, ProjectCategories } from '../components/projects/ProjectFilters';
import { ProjectResults } from '../components/projects/ProjectResults';
import { projects } from '../mock';
import { useProjectFilters } from '../hooks/useProjectFilters';
import { useSeo } from '../hooks/useSeo';

export default function ProjectsPage() {
  useSeo({
    title: 'Projeler',
    description: 'Membratek tarafindan tamamlanan 500+ prestijli proje. Stadyumlar, universiteler, pazar yerleri, fabrika ve depo cadirlari, parklardan otoparklara genis portfoy.',
    path: '/projeler',
  });
  const filters = useProjectFilters(projects);
  return (
    <main>
      <PageHeader eyebrow="PROJELERIMIZ" title="Prestijli Projelerimize Goz Atin" description="Turkiye genelinde tamamladigimiz 500+ prestijli projeden bazilari. Aramak icin yazin, filtreleyin veya siralayin." />
      <ProjectSearchControls {...filters} />
      <ProjectCategories {...filters} />
      <ProjectResults {...filters} />
      <CTA />
    </main>
  );
}